import React from "react";
import { Avatar, Badge, Card, Space, Typography, Switch, List } from "antd";
import { useAuth } from "../../../hooks/auth.jsx";
import { TiUserOutline } from "react-icons/ti";
import { useTheme } from "../../../contexts/ThemeContext.jsx";
import { Bell, Sun, Moon, SignOut, RocketLaunch, ArrowSquareOut } from "@phosphor-icons/react";
import { useNotifications } from "../../../contexts/NotificationsContext.jsx";

const { Text } = Typography;

const UserProfileCard = ({ tenant, userRole, appVersion = "1.0.0", user, onCloseDropdown }) => {
  const { signOut } = useAuth();
  const { theme, isDarkMode, toggleTheme } = useTheme();
  const { unread, openPanel } = useNotifications();

  const menuItems = [
    {
      key: "notifications",
      label: "Notificações",
      icon: <Bell size={18} />,
      action: (
        <Badge
          count={unread}
          size="small"
          overflowCount={99}
          aria-label={`Notificações não lidas: ${unread}`}
        />
      ),
      onClick: () => {
        onCloseDropdown && onCloseDropdown();
        openPanel();
      },
    },
    {
      key: 'theme',
      label: 'Tema Escuro',
      icon: isDarkMode ? <Moon size={18} weight="fill" /> : <Sun size={18} />,
      action: (
        <Switch 
          size="small"
          checked={isDarkMode} 
          onChange={toggleTheme}
        />
      ),
    },
    {
      key: 'logout',
      label: 'Sair',
      icon: <SignOut size={18} />,
      danger: true,
      onClick: () => { onCloseDropdown && onCloseDropdown(); signOut(); },
    }
  ];
  
  return (
    <Card
      style={{
        backgroundColor: theme.cardBackground,
        width: 300,
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        border: `1px solid ${theme.border}`,
        padding: 0,
        overflow: 'hidden'
      }}
      bodyStyle={{ padding: 0 }}
    >
      <div style={{ padding: '24px 24px 16px', display: 'flex', flexDirection: 'column', alignItems: 'center', borderBottom: `1px solid ${theme.border}` }}>
        <Avatar
          size={64}
          icon={<TiUserOutline />}
          src={user?.files || user?.userName?.charAt(0)?.toUpperCase()}
          style={{ 
            backgroundColor: theme.primary,
            marginBottom: 12,
            border: `2px solid ${theme.cardBackground}`,
            boxShadow: `0 0 0 2px ${theme.primary}`
          }}
        >
          {user?.files || user?.userName?.charAt(0)?.toUpperCase()}
        </Avatar>
        <Text style={{ color: theme.textSecondary, fontSize: 16, fontWeight: 600, marginBottom: 4 }}>
          {user?.userName || 'Usuário'}
        </Text>
        <Text style={{ color: theme.textSecondary, fontSize: 12 }}>
          {tenant?.nome}
        </Text>
      </div>

      <List
        itemLayout="horizontal"
        dataSource={menuItems}
        renderItem={(item) => (
          (() => {
            const baseBackground = item.background || "transparent";
            const hoverBackground = item.hoverBackground || theme.backgroundTertiary || "#f5f5f530";
            const textColor = item.textColor || (item.danger ? theme.error : theme.textSecondary);

            return (
          <List.Item 
            style={{ 
              padding: '12px 24px',
              cursor: item.onClick ? 'pointer' : 'default',
              borderBottom: `1px solid ${theme.border}`,
              transition: 'background 0.2s',
              background: baseBackground,
            }}
            className="user-menu-item"
            onClick={item.onClick}
            onMouseEnter={(e) => {
              if (item.onClick) e.currentTarget.style.background = hoverBackground;
            }}
            onMouseLeave={(e) => {
              if (item.onClick) e.currentTarget.style.background = baseBackground;
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, color: textColor }}>
                {item.icon}
                <Text style={{ color: textColor }}>{item.label}</Text>
              </div>
              {item.action}
            </div>
          </List.Item>
            );
          })()
        )}
      />
      
      <div style={{ padding: '8px 24px', textAlign: 'center' }}>
         <Text style={{ fontSize: 10, color: theme.textTertiary }}>Versão {appVersion}</Text>
      </div>
    </Card>
  );
};

export default UserProfileCard;
